<template>
	<div class="main">
		<div class="bootbox modal fade in show" tabindex="-1" role="dialog" style="display: block;">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-body">
						<button type="button" class="bootbox-close-button close" data-dismiss="modal" aria-hidden="true" style="margin-top: -10px;" @click="closePopup">×</button>
						<div class="bootbox-body">
							<section class="panel">
								<div class="panel-body">
									<div class="row form-group">
										<div class="col-md-12">
											<table class="table table-hover table-bordered">
												<thead>
													<tr>
														<!-- <td style="width:10%;"></td> -->
														<td style="width:20%;">標題</td>
														<td style="width:80%;">內容</td>
													</tr>
												</thead>
												<tbody>
													<tr v-for="(item,key) in sampleOpinionList" :key="key" @click="eventSelection(item)">
														<!-- <td><a class="btn btn-default btn-block" ></a></td> -->
														<td data-title="標題">{{item.title}}</td>
														<td data-title="內容">{{item.opinion}}</td>
													</tr>
												</tbody>
											</table>
										</div>
									</div>
									
								</div>
							</section>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	data(){
		return {
			reviewOpinion:"",
			sampleOpinionList:[]
		};
	},
	mounted(){
		const api = "/api/Common/sampleOpinionList";
		this.$axios.post(api).then(resp => {
			this.sampleOpinionList = resp.data.data;
		});

	},
	methods:{
		closePopup() {
			this.$parent.showOpinionPopControl(false);
		},
		eventSelection(item){
			this.$parent.setOpinionValue(item.opinion);
		}
	}

}
</script>